export default {"src":"/_next/static/media/blob1.d98e23af.svg","height":106,"width":212,"blurWidth":0,"blurHeight":0};